<template>
  <AdminActivities v-if="isAdmin" ref="fileTable" />
</template>

<script>
import AdminActivities from "@/components/Dashboard/Views/AdminActivities/AdminActivities.vue";
import store from "@/store/store";
export default {
  components: {
    AdminActivities,
  },
  computed: {
    isAdmin() {
      const user = store.state.auth.user;
      return user && user.role === "admin";
    }
  },
  mounted() {
    if (!this.isAdmin) {
      this.$router.push("/overview");
    }
  },
  methods: {
    refreshFiles() {
      this.$refs.fileTable && this.$refs.fileTable.$forceUpdate();
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/AdminActivities/index.vue